export enum Role {
  SuperAdmin = "super-admin",
  CompanyAdmin = "company-admin",
  Employee = "employee",
  Customer = "customer",
}
